(function(){
  function fixImages() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper) return;
    // Make the media container fill its column
    var container = wrapper.querySelector('.product-media-container');
    if (container) {
      container.style.setProperty('width','100%','important');
      container.style.setProperty('max-width','100%','important');
      container.style.setProperty('height','auto','important');
    }
    // Remove Dawn's aspect-ratio padding trick
    var medias = wrapper.querySelectorAll('.product__media');
    medias.forEach(function(m){
      m.style.setProperty('position','static','important');
      m.style.setProperty('padding-bottom','0','important');
      m.style.setProperty('width','100%','important');
    });
    // Force the actual image to be a normal block element
    var imgs = wrapper.querySelectorAll('img');
    imgs.forEach(function(img){
      img.style.setProperty('width','100%','important');
      img.style.setProperty('max-width','100%','important');
      img.style.setProperty('height','auto','important');
      img.style.setProperty('object-fit','contain','important');
      img.style.setProperty('display','block','important');
      img.style.setProperty('position','relative','important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixImages);
  } else {
    fixImages();
  }
})();
